import React from 'react';
import styled from 'styled-components';
import { getMetricName, isHiddenMetric } from 'utils/modelFeatures';
import NwDrawer from 'components/Gui/NwDrawer';
import ModelAdditionalInfo, { hasAdditionalInfo } from './ModelAdditionalInfo';
import ModelFeatureValue from './ModelFeatureValue';

const ModelFeaturesAllConversionsWrapper = styled.div`
    margin-top: 1rem;

    .model-additional-info {
        .model-birthdate,
        .model-age,
        .model-customfield {
            display: flex;
            flex-wrap: nowrap;
            padding: .5rem;
            font-size: 1rem;
            border-bottom: ${props => props.theme.DefaultBorder};
            align-items: flex-start;
            justify-content: space-between;

            .model-birthdate-name,
            .model-age-name,
            .model-customfield-name {
                text-align: left;
                font-size: 1.25rem;
            }

            .model-birthdate-value,
            .model-age-value,
            .model-customfield-value {
                text-align: right;
                font-weight: ${props => props.theme.FontWeightBold};
            }
        }
    }

    .model-feature {
        display: flex;
        flex-wrap: nowrap;
        padding: .5rem;
        font-size: 1rem;
        border-bottom: ${props => props.theme.DefaultBorder};
        align-items: flex-start;
        justify-content: space-between;

        .model-feature-name {
            text-align: left;
            font-size: 1.25rem;
        }
        .model-feature-values {
            text-align: right;
            .model-feature-value {
                font-weight: ${props => props.theme.FontWeightBold};
                em {
                    font-style: normal;
                    text-transform: uppercase;
                    font-weight: ${props => props.theme.FontWeightBase};
                    font-size: .9rem;
                    padding-left: .5rem;
                }
            }
        }
    }
`

const ModelInfoFeaturesDrawer = ({
    model,
    modelFeatures,
    features,
    clientConfig,
    onClose
}) => {
    const showAdditionalInfo = hasAdditionalInfo(model, clientConfig);
    const isIconFeature = (feature) => feature.type === 'Boolean' || feature.type === 'Rating';

    return (
        <NwDrawer
            title="Model Features"
            onClose={onClose}
            open
        >
            <ModelFeaturesAllConversionsWrapper>
                {showAdditionalInfo &&
                    <ModelAdditionalInfo model={model} clientConfig={clientConfig} />
                }

                {modelFeatures.map((feature) => (
                    <div className="model-feature" key={feature.id || feature.displayName}>
                        <div className="model-feature-name">{feature.displayName}</div>
                        <div className="model-feature-values">
                            {isIconFeature(feature)
                                ?
                                <div className="model-feature-value">
                                    <ModelFeatureValue feature={feature} />
                                </div>
                                :
                                feature.displayValues.map((val) => {
                                    if (!isHiddenMetric(val.metric, model.Gender)) {
                                        return (
                                            <div className="model-feature-value" key={`feat-val-${val.metric || feature.id}`}>
                                                {val.value}
                                                {val.metric &&
                                                    <em>{getMetricName(val.metric, feature.conversionName, features, model.Gender)}</em>
                                                }
                                            </div>
                                        );
                                    }
                                    return null;
                                })
                            }
                        </div>
                    </div>
                ))}
            </ModelFeaturesAllConversionsWrapper>
        </NwDrawer>
    );
};

export default ModelInfoFeaturesDrawer;
